// extracted by mini-css-extract-plugin
export default {"Footer":"zS0qq3x0K-MUraJo4ugpbw=="};